import { createStore } from 'satcheljs';
/**
 * Selector to get UI store for folder permissions package
 */
export var getStore = createStore('folderPermissionsStore', {
    folderId: null,
    permissions: [],
    selectedPermissionIndex: 0,
    showAddUserDialog: false,
    showFolderPermissionsDialog: false,
    showLoader: false,
});
export default getStore();
//# sourceMappingURL=store.js.map